import {type RunWithHistory} from '../../../types/run';

/** Whether a run has at least one history row containing the media key. */
export function runHasMediaKey(
  run: RunWithHistory,
  mediaKey?: string | null
): boolean {
  if (mediaKey == null) {
    return true;
  }
  return run.history?.some(row => mediaKey in row) === true;
}
